import { useEffect, useState } from "react";
import {
  FaClipboardList,
  FaExclamationTriangle,
  FaUserTimes,
} from "react-icons/fa";
import { BsBellFill } from "react-icons/bs";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Loading } from "../shared/loading/Loading";
import { Link } from "react-router-dom";
import { usePendencias } from "../../hooks/useFornecedores";
import { useAuth } from "../../contexts/AuthContext";
import Style from "./index.module.css";

export const Pendencia = () => {
  const { user } = useAuth();
  const [isMobile, setIsMobile] = useState(false);

  const {
    fornecedoresSemAvaliacao,
    fornecedoresSemQuestionario,
    fornecedoresProximosAoVencimento,
    setPageAvaliacao,
    totalPagesAvaliacao,
    pageAvaliacao,
    setPageQuestionario,
    totalPagesQuestionario,
    pageQuestionario,
    setPageVencimento,
    totalPagesVencimento,
    pageVencimento,
    isLoading,
  } = usePendencias(user);

  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth < 768);
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  if (user.tipusu === "COMPRADOR" && isLoading)
    return <Loading text="Carregando pendências..." />;

  return (
    <main className={Style.container}>
      {user.tipusu === "COMPRADOR" && (
        <>
          <h2>
            <BsBellFill style={{ marginRight: 8 }} /> Pendências
          </h2>

          <section className={Style.gridContainerComprador}>
            {/* Questionário Pendente */}
            <div className={Style.gridCard}>
              <h3>
                <FaClipboardList /> Questionário Pendente
                <p>({fornecedoresSemQuestionario?.total ?? 0} fornecedores) </p>
              </h3>

              <ul>
                {fornecedoresSemQuestionario?.docs?.length > 0 ? (
                  fornecedoresSemQuestionario.docs.map((item, i) => (
                    <li key={i}>
                      <Link
                        to={`/fornecedores/${item.codcli}`}
                        className={Style.link}
                      >
                        {item.codcli} - {item.nomcli} (
                        {item.cgccli || "N/A"})
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Nenhum fornecedor com o questionário pendente</li>
                )}
              </ul>

              {totalPagesQuestionario > 1 && (
                <div className={Style.pagination}>
                  <div className={Style.paginationControls}>
                    <button onClick={() => setPageQuestionario((p) => Math.max(p - 1, 1))} disabled={pageQuestionario === 1}>
                      {isMobile ? <ChevronLeft size={16} /> : "‹"}
                    </button>
                    <button onClick={() => setPageQuestionario((p) => Math.min(p + 1, totalPagesQuestionario))} disabled={pageQuestionario === totalPagesQuestionario}>
                      {isMobile ? <ChevronRight size={16} /> : "›"}
                    </button>
                  </div>
                  <span className={Style.paginationInfo}>Página {pageQuestionario} de {totalPagesQuestionario}</span>
                </div>
              )}
            </div>

            {/* Próximo ao Vencimento (estático por enquanto) */}
            <div className={Style.gridCard}>
              <h3>
                <FaExclamationTriangle /> Próximo ao Vencimento
                <p>({fornecedoresProximosAoVencimento?.total ?? 0} fornecedores)</p>
              </h3>
              <ul>
                {fornecedoresProximosAoVencimento?.docs?.length > 0 ? (
                  fornecedoresProximosAoVencimento.docs.map((item, i) => (
                    <li key={i}>
                      <Link
                        to={`/fornecedores/${item.codcli}`}
                        className={Style.link}
                      >
                        {item.codcli} - {item.nomcli} (
                        {item.cgccli || "N/A"})
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Nenhum fornecedor com o cadastro próximo ao vencimento de 360 dias</li>
                )}
              </ul>

              {totalPagesVencimento > 1 && (
                <div className={Style.pagination}>
                  <div className={Style.paginationControls}>
                    <button onClick={() => setPageVencimento((p) => Math.max(p - 1, 1))} disabled={pageVencimento === 1}>
                      {isMobile ? <ChevronLeft size={16} /> : "‹"}
                    </button>
                    <button onClick={() => setPageVencimento((p) => Math.min(p + 1, totalPagesVencimento))} disabled={pageVencimento === totalPagesVencimento}>
                      {isMobile ? <ChevronRight size={16} /> : "›"}
                    </button>
                  </div>
                  <span className={Style.paginationInfo}>Página {pageVencimento} de {totalPagesVencimento}</span>
                </div>
              )}
            </div>

            {/* Sem Avaliação */}
            <div className={Style.gridCard}>
              <h3>
                <FaUserTimes /> Sem Avaliação
                <p>({fornecedoresSemAvaliacao?.total ?? 0} fornecedores)</p>
              </h3>
              <ul>
                {fornecedoresSemAvaliacao?.docs?.length > 0 ? (
                  fornecedoresSemAvaliacao.docs.map((item, i) => (
                    <li key={i}>
                      <Link
                        to={`/fornecedores/${item.codcli}`}
                        className={Style.link}
                      >
                        {item.codcli} - {item.nomcli} (
                        {item.cgccli || "N/A"})
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Nenhum fornecedor sem avaliação no sistema</li>
                )}
              </ul>

              {totalPagesAvaliacao > 1 && (
                <div className={Style.pagination}>
                  <div className={Style.paginationControls}>
                    <button onClick={() => setPageAvaliacao((p) => Math.max(p - 1, 1))} disabled={pageAvaliacao === 1}>
                      {isMobile ? <ChevronLeft size={16} /> : "‹"}
                    </button>
                    <button onClick={() => setPageAvaliacao((p) => Math.min(p + 1, totalPagesAvaliacao))} disabled={pageQuestionario === totalPagesAvaliacao}>
                      {isMobile ? <ChevronRight size={16} /> : "›"}
                    </button>
                  </div>
                  <span className={Style.paginationInfo}>Página {pageAvaliacao} de {totalPagesAvaliacao}</span>
                </div>
              )}
            </div>
          </section>
        </>
      )}
    </main>
  );
};